<span>{{ hideCurrency ? (exchangedMoney | formatNumber) : parsedCurrency + (exchangedMoney | formatNumber | negativeNumber) }}</span>
